import { useContext, useState } from "react"
import { gql, useQuery } from "@apollo/client"
import _ from "lodash"

import { LoaderSmall } from "./Loaders"

// Context
import { UserContext } from "../context/userContext"

export default function SupervisorName({ staff_id, organization_id }) {
  const userCtx = useContext(UserContext)
  const [staffData, setStaffData] = useState(null)

  const GET_SUPERVISOR = gql`
    query user($staff_id: ID!, $organization_id: ID!) {
      user(staff_id: $staff_id, organization_id: $organization_id) {
        staff_name_first
        staff_name_last
      }
    }
  `

  const { loading } = useQuery(GET_SUPERVISOR, {
    variables: {
      staff_id: staff_id,
      organization_id: organization_id,
    },
    context: {
      headers: {
        //user: JSON.stringify(user),2
      },
    },
    skip: !userCtx,
    fetchPolicy: "network-only",
    onCompleted: ({ user }) => {
      const name =
        (!_.isEmpty(userCtx.session.user.staff_name_first)
          ? userCtx.session.user.staff_name_first
          : "") +
        " " +
        (!_.isEmpty(userCtx.session.user.staff_name_last)
          ? userCtx.session.user.staff_name_last
          : "")
      return setStaffData(name)
    },
  })

  if (loading) {
    return (
      <div>
        <LoaderSmall />
      </div>
    )
  }

  return <span>{!_.isEmpty(staffData) ? staffData : "N/A"}</span>
}
